import React,{useEffect,useState}from"react";
import{Box,Button,Paper,Stack,Typography}from"@mui/material";
import ArrowBackRoundedIcon from"@mui/icons-material/ArrowBackRounded";
import{useNavigate}from"react-router-dom";
import Sidebar from"../AdminPanel/Sidebar";
import TopBar from"../AdminPanel/TopBar";
import{useDashboardTheme}from"../../../context/DashboardThemeContext";
import{useAlert}from"../../../context/AlertContext";
import ProductForm from"./Products/ProductForm";
import ProductImages from"./Products/ProductImages";

export default function Products(){
  const[sidebarOpen,setSidebarOpen]=useState(true);
  const{dashboardTheme}=useDashboardTheme();
  const{showSuccess,showError}=useAlert();
  const navigate=useNavigate();
  const[nextCode,setNextCode]=useState("Cargando...");
  const[saving,setSaving]=useState(false);
  const[form,setForm]=useState({
    name:"",
    ecommerce:true,
    control_stock:false,
    stock_minimo:"",
    pvp1:"",
    iva_porcentaje:15,
    category:null,
    brand:null,
    barcode:"",
    codigo_auxiliar:"",
    estado:"activo",
    description:"",
  });
  const[images,setImages]=useState([]);
  const token=localStorage.getItem("accessToken");

  const outlinedButtonSx={
    minHeight:40,
    px:2.4,
    borderRadius:"12px",
    textTransform:"none",
    fontWeight:700,
    color:dashboardTheme.button_color,
    borderColor:dashboardTheme.button_color,
    boxShadow:"none",
    "&:hover":{
      borderColor:dashboardTheme.button_color,
      bgcolor:`${dashboardTheme.button_color}12`,
      boxShadow:"none",
    },
  };

  const loadNextCode=async()=>{
    try{
      const response=await fetch("/api/products/products/",{headers:{Authorization:`Bearer ${token}`}});
      const data=await response.json();
      if(!response.ok){
        setNextCode("Se asignará automáticamente");
        return;
      }
      const results=data.results||[];
      const maxSeq=results.reduce((max,item)=>{
        const seq=Number(item.product_seq||0);
        return seq>max?seq:max;
      },0);
      setNextCode(`P${String(maxSeq+1).padStart(7,"0")}`);
    }catch{
      setNextCode("Se asignará automáticamente");
    }
  };

  useEffect(()=>{
    loadNextCode();
  },[]);

  const parseBackendError=(data)=>{
    const error=data?.error||data?.detail;
    if(!error)return"No se pudo crear el producto.";
    if(typeof error==="string")return error;
    if(typeof error==="object")return Object.values(error).flat().join(" ");
    return"No se pudo crear el producto.";
  };

  const validateForm=()=>{
    if(!form.name.trim()){
      showError("El nombre del producto es obligatorio.");
      return false;
    }
    if(form.pvp1===""||Number(form.pvp1)<0){
      showError("El PVP debe ser mayor o igual a cero.");
      return false;
    }
    if(form.control_stock&&form.stock_minimo!==""&&Number(form.stock_minimo)<0){
      showError("El stock mínimo no puede ser negativo.");
      return false;
    }
    return true;
  };

  const saveProduct=async()=>{
    if(!validateForm()||saving)return;
    try{
      setSaving(true);
      const fd=new FormData();
      fd.append("name",form.name.trim());
      fd.append("ecommerce",form.ecommerce?"true":"false");
      fd.append("control_stock",form.control_stock?"true":"false");
      fd.append("stock_minimo",form.control_stock?(form.stock_minimo===""?"0":form.stock_minimo):"0");
      fd.append("pvp1",form.pvp1);
      fd.append("iva_porcentaje",form.iva_porcentaje);
      fd.append("aplica_ice","false");
      fd.append("ice_porcentaje","0");
      fd.append("category_id",form.category?.id||"");
      fd.append("brand_id",form.brand?.id||"");
      fd.append("barcode",form.control_stock?form.barcode.trim():"");
      fd.append("codigo_auxiliar",form.control_stock?form.codigo_auxiliar.trim():"");
      fd.append("estado",form.estado);
      fd.append("description",form.description.trim());
      images.forEach((item)=>{
        if(item.file)fd.append("images",item.file);
      });
      const response=await fetch("/api/products/products/create/",{
        method:"POST",
        headers:{Authorization:`Bearer ${token}`},
        body:fd,
      });
      const data=await response.json();
      if(!response.ok){
        showError(parseBackendError(data));
        return;
      }
      showSuccess(data.mensaje||"Producto añadido exitosamente.");
      setTimeout(()=>navigate(-1),700);
    }catch{
      showError("Error de conexión.");
    }finally{
      setSaving(false);
    }
  };

  return(
    <Box sx={{minHeight:"100vh",bgcolor:dashboardTheme.dashboard_background,display:"flex",color:dashboardTheme.text_color,overflowX:"hidden"}}>
      <Sidebar open={sidebarOpen} onClose={()=>setSidebarOpen(false)}/>
      <Box sx={{flex:1,minWidth:0,minHeight:"100vh",display:"flex",flexDirection:"column"}}>
        <TopBar sidebarOpen={sidebarOpen} onToggleSidebar={()=>setSidebarOpen((prev)=>!prev)}/>
        <Box component="main" sx={{flex:1,width:"100%",p:{xs:1.5,sm:2,md:3}}}>
          <Box sx={{width:{xs:"100%",lg:"95%"},mx:"auto",mt:{xs:1,md:1.5}}}>
            <Box sx={{display:"flex",alignItems:{xs:"stretch",sm:"center"},justifyContent:"space-between",flexDirection:{xs:"column",sm:"row"},gap:1.5,mb:{xs:1.5,md:2}}}>
              <Typography sx={{fontSize:{xs:24,sm:26,md:30},fontWeight:600,color:dashboardTheme.primary_color,lineHeight:1.2}}>Nuevo Producto</Typography>
              <Button variant="outlined" startIcon={<ArrowBackRoundedIcon/>} onClick={()=>navigate(-1)} sx={outlinedButtonSx}>Regresar</Button>
            </Box>
            <Paper elevation={0} sx={{borderRadius:{xs:"10px",md:"12px"},border:`1px solid ${dashboardTheme.border_color}`,bgcolor:dashboardTheme.card_background,p:{xs:1.5,sm:2,md:2.5}}}>
              <Stack spacing={3}>
                <ProductForm form={form} setForm={setForm} nextCode={nextCode} onSubmit={saveProduct} saving={saving}/>
                <ProductImages images={images} setImages={setImages}/>
              </Stack>
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}